"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "presenterFeatured", {
  enumerable: true,
  get: function get() {
    return _presenterFeatured["default"];
  }
});
var _presenterFeatured = _interopRequireDefault(require("./presenterFeatured"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }